import { render, staticRenderFns } from "./cardEmbarazo.vue?vue&type=template&id=424c026c"
import script from "./cardEmbarazo.vue?vue&type=script&lang=js"
export * from "./cardEmbarazo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports